export default "__VITE_ASSET__CloqE5vd__"